import React from "react";
import { Tooltip, Typography } from "@mui/material";
import "./orderDetails2.css";
import "../../analytics/analytics.css";
import ReactCountryFlag from "react-country-flag";
import { upiIntentLogoDictionary } from "../../utils/utils";
import { Link } from "react-router-dom";

export const OrderCategoryDetailsGrid = ({
  categories,
  data,
  paymentMethodData,
}) => {
  return (
    <div className="order-category-root">
      {categories.map((val, id) => {
        return (
          data[id] && (
            <div className="order-category" key={id}>
              <Typography className="labelSemiBoldColored">{val}</Typography>
              {val === "Method" || val === "Application"
                ? data[id] && (
                    <div className="brand-logo-typography">
                      {((val === "Application" &&
                        upiIntentLogoDictionary(data[id])) ||
                        paymentMethodData?.find(
                          (obj) => obj?.brand === data[id]
                        )?.logoUrl) && (
                        <div className="payment-logo">
                          <img
                            src={
                              val === "Application"
                                ? upiIntentLogoDictionary(data[id])
                                : paymentMethodData?.find(
                                    (obj) => obj?.brand === data[id]
                                  )?.logoUrl
                            }
                          />
                        </div>
                      )}
                      <Typography
                        className="bodyB2SemiBoldColored"
                        sx={{ paddingTop: "8px" }}
                      >
                        {
                          paymentMethodData?.find(
                            (obj) => obj?.brand === data[id]
                          )?.title
                        }
                      </Typography>
                    </div>
                  )
                : val === "Country code"
                ? data[id] && (
                    <div className="brand-logo-typography">
                      <div className="payment-logo">
                        <ReactCountryFlag countryCode={data[id]} svg />
                      </div>
                      <Typography
                        className="bodyB2SemiBoldColored"
                        sx={{ paddingTop: "8px" }}
                      >
                        {data[id]}
                      </Typography>
                    </div>
                  )
                : val == "Origin"
                ? data[id] && (
                    <div className="brand-logo-typography">
                      <Typography
                        className="bodyB2SemiBoldColored"
                        sx={{ paddingTop: "8px" }}
                      >
                        {data[id]}
                      </Typography>
                      <Link
                        to={`/paymentLinks?token=${data[id]}`}
                        target="_blank"
                      >
                        <div className="payment-logo">
                          <img
                            src="/assets/redirect_icon.svg"
                            alt="redirect_icon"
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </Link>
                    </div>
                  )
                : val == "Tenure"
                ? data[id] && (
                    <div className="brand-logo-typography">
                      <Typography
                        className="bodyB2SemiBoldColored"
                        sx={{ paddingTop: "8px" }}
                      >
                        {data[id] < 10 ? "0" + data[id] : data[id]} Months EMI
                      </Typography>
                    </div>
                  )
                : data[id] && (
                    <>
                      <Tooltip
                        title={data[id]}
                        placement="right-start"
                        arrow
                        followCursor
                      >
                        <Typography
                          className="bodyB2SemiBoldColored"
                          sx={{ paddingTop: "8px" }}
                        >
                          {data[id]}
                        </Typography>
                      </Tooltip>
                    </>
                  )}
            </div>
          )
        );
      })}
    </div>
  );
};
